import { Injectable } from '@angular/core';
import { API_METHODS, API_URL } from 'common/constants/sm-constants';
import { SystemService } from '../../../core-services/system.service';
import { FormDataService } from '../../base-data-services/form-data.service';
import { SmApiService } from '../../../core-services/sm-api.service';
import { environment } from 'src/environments/environment';
import { BatchesModel } from 'common/models/page-models/Batches/batches-data-model';
import moment from 'moment';
import { DataModel } from 'common/models/utility-models/base-model';

@Injectable({
  providedIn: 'root',
})
export class BatchesFormDataService extends FormDataService<BatchesModel> {
  constructor(http: SmApiService, protected override ss: SystemService) {
    super(API_URL.addBatch, http, ss);
  }
  override getEditUrlAndMethod() {
    const edit = {
      url: environment.apiUrl + API_URL.batchesedit,
      method: API_METHODS.post,
    };
    // console.log(edit, id);
    return edit;
  }

  override getUpdatePayload(data) {
        let payload;
         payload = {
            id: data.id
        }
        return payload;
    }

  // override modifyAPIResponse(response: any) {
  //     return response['details'];
  // }

  createInstance(): BatchesModel {
    return new BatchesModel();
  }

  override getUpdateUrl() {
    return API_URL.updateBatches;
  }

  override modifyPostModel(formModel, dataModel) {
    // console.log(formModel, dataModel, "MODEL")
    // formModel['duration_start'] = this.isFormattedDate(formModel['duration_start'])?moment(formModel['duration_start']).format('DD-MM-YYYY') === 'Invalid date' ? dataModel.duration_start : moment(formModel['duration_start']).format('DD-MM-YYYY'):formModel['duration_start']
    // formModel['duration_end'] = this.isFormattedDate(formModel['duration_end'])?moment(formModel['duration_end']).format('DD-MM-YYYY') === 'Invalid date' ? dataModel.duration_end : moment(formModel['duration_end']).format('DD-MM-YYYY'):formModel['duration_end']
    formModel['duration_start'] = this.formatDateToDDMMYYYY(formModel['duration_start'])
    formModel['duration_end'] = this.formatDateToDDMMYYYY(formModel['duration_end'])
    // console.log(formModel);
    return formModel
    // return formModel;
  }

  formatDateToDDMMYYYY(input: string): string {
    const ddMmYyyyRegex = /^\d{2}\/\d{2}\/\d{4}$/;
  
    if (ddMmYyyyRegex.test(input)) {
      return input;
    } else {
      const date = new Date(input);
      if (isNaN(date.getTime())) {
        throw new Error("Invalid date format");
      }
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
  
      return `${day}-${month}-${year}`;
    }
  }
  
  override modifyAPIResponse(response: any) {
    // console.log(response.details, "RESPONSE")
    const dataModel = this.createInstance();
    dataModel.id = response.details.id;
    dataModel.batch_number = response?.details?.batch_number;
    dataModel.duration_start = response?.details?.duration_start ? new Date(response.details.duration_start) : "";
    dataModel.duration_end = response?.details?.duration_end ? new Date(response.details.duration_end) : "";
    return dataModel;
  }

  // override beforePostData(
  //   model: any,
  //   metamodel: any,
  //   dataModel: any
  // ): Promise<BatchesModel> {
  //   return new Promise<any>((resolve, reject) => {
  //     console.log(model,metamodel,dataModel);
  //     model.duration_end = this.ss.convertToDateFormat(model.duration_end);
  //     model.duration_start = this.ss.convertToDateFormat(model.duration_start);
  //     resolve(model);
  //   });
  // }

  //   override afterGetData(model: BatchesModel): Promise<BatchesModel> {
  //     return new Promise<any>((resolve, reject) => {
  //       console.log(model)
  //       resolve(model)
  //     });
  //   }
}

